const $ = window.jQuery;
const $window = window.$window || $(window);

const MobileMenu = {

    init() {

        let $mobile_menu = $('.MobileMenu');

        $('#js-mobile-nav-toggle').click(function (event) {
            event.preventDefault();
            $mobile_menu.removeClass('hidden');
            $('.MobileMenu__close').one('click', function () {
                $mobile_menu.addClass('hidden');
            });
        });
    },

};

export default MobileMenu;